import { Loader2, LockOpen } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";

import { useTran } from "@/hooks";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CardFooter } from "@/components/ui/card";
import { useManageUserPageData } from "../hooks";

const ManageUserFooter = observer(() => {
  const { t } = useTran();
  const { userId } = useParams();
  const {
    statusValue,
    statusLabel,
    saving,
    unlocking,
    isCompanyAdmin,
    handleUnlock,
    canUpdate,
    hasChanges,
  } = useManageUserPageData({ userId });

  const badgeClassName =
    statusValue === "active"
      ? "border-green-500 text-green-600 bg-green-50"
      : statusValue === "locked"
        ? "border-red-500 text-red-600 bg-red-50"
        : "border-yellow-500 text-yellow-600 bg-yellow-50";

  return (
    <CardFooter className="flex flex-col gap-3 pt-0 sm:flex-row sm:items-center sm:justify-between">
      {isCompanyAdmin ? (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          {t("Current status:")}
          {statusValue ? (
            <Badge
              variant="outline"
              className={`uppercase font-medium ${badgeClassName}`}
            >
              {statusLabel}
            </Badge>
          ) : (
            <span>{t("Not set")}</span>
          )}
        </div>
      ) : (
        <div />
      )}
      <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
        {isCompanyAdmin && statusValue === "locked" ? (
          <Button
            type="button"
            variant="outline"
            className="gap-2"
            onClick={handleUnlock}
            disabled={unlocking}
          >
            {unlocking ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <LockOpen className="h-4 w-4" />
            )}
            {unlocking ? t("Unlocking...") : t("Unlock account")}
          </Button>
        ) : null}
        {/* <Button
          type="button"
          variant="outline"
          className="gap-2"
          onClick={handlePasswordReset}
          disabled={sendingReset}
        >
          {sendingReset ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Mail className="h-4 w-4" />
          )}
          {sendingReset ? t("Sending...") : t("Send password reset")}
        </Button> */}
        <Button
          type="submit"
          form="manage-user-form"
          disabled={saving || !hasChanges || !canUpdate()}
          className="w-full gap-2 sm:w-auto"
        >
          {saving && <Loader2 className="h-4 w-4 animate-spin" />}
          {saving ? t("Saving...") : t("Save changes")}
        </Button>
      </div>
    </CardFooter>
  );
});

export default ManageUserFooter;
